function selectComponents() {
  $('.components__notice').addClass('components-notice-active');
  $('.components__selected-button').addClass('components-selected-button-active');
  app.showProtocolModal && app.showProtocolModal.hide();
  app.protocolItemModal && app.protocolItemModal.hide();
  viewer.clearSelection();
}

function componentsSelected() {

  // TODO select and save

  var currSelection = NOP_VIEWER.getSelection();
  var selected_components = [];

  if (currSelection.length) {
    $.each(currSelection, function (index, item) {
      if (nodeProperties[item]) {
        var properties = nodeProperties[item];
        var cpID;
        var forgeID;

        $.each(properties, function (index2, property) {
          if (property.displayName == 'cpID') {
            cpID = property.displayValue;
          }
          if (property.displayName == 'GUID' && property.displayCategory == 'Item') {
            forgeID = property.displayValue;
          }

          if (cpID && forgeID) {
            return false;
          }
        });

        selected_components.push({
          cpID: cpID,
          forgeID: forgeID,
        });
      }
    });
  }

  $('#protocol-item-modal__components-button').data('selected_components', selected_components);

  $('#protocol-item-modal__components-button').html(
    selected_components && selected_components.length ? __('changeComponentsButton').replace('{n}', selected_components.length) : __('selectComponentsButton')
  );

  // console.log('selected_components', selected_components);

  viewer.clearSelection();

  $('.components__notice').removeClass('components-notice-active');
  $('.components__selected-button').removeClass('components-selected-button-active');
  app.showProtocolModal && app.showProtocolModal.show();
  app.protocolItemModal && app.protocolItemModal.show();
}
